import { formatRegisteredAtForHeading } from '@/pages/SealedVinylPage/lib/utils'

import { HeadingDate, HeadingSectionContainer } from './styles'

interface HeadingSectionProps {
  /** Java LocalDateTime 배열 [y, M, d, h, m, s] — product-orders/detail registeredAt */
  registeredAt: number[]
}

export function HeadingSection({ registeredAt }: HeadingSectionProps) {
  return (
    <HeadingSectionContainer>
      <HeadingDate>{formatRegisteredAtForHeading(registeredAt)}</HeadingDate>
    </HeadingSectionContainer>
  )
}
